<template>
  <div class="sp_login">
    <div class="sp_login_introduce">
      <h1>Sangfor Support Portal</h1>
      <p>Welcome to Sangfor Support Portal.</p>
      <p>At Sangfor, we aspire to make IT simpler, more secure, and valuable.</p>
      <p>This support portal is to empower our users to monitor, manage, view, activate and update their Sangfor assets. You can take charge of your assets through the user-friendly Sangfor Support Portal.</p>
    </div>

    <div class="sp_login_module">
      <sangfor-logo class="title-logo"></sangfor-logo>

      <div class="login-content">
        <div>
          <h3 class="product-name">Sangfor Support Portal</h3>
        </div>
        <!-- 表单模块开始 -->
        <el-form :model="loginForm"
                 ref="loginForm"
                 :rules="loginRules"
                 class="sp_login_form">
          <el-form-item :label="$t('loginModule.email')+'：'"
                        prop="email">
            <el-input type="text"
                      v-model="loginForm.email"
                      autocomplete="on"
                      placeholder="Please input your emai: e.g. john@sangfor.com"
                      @keyup.enter.native="submitFrom('loginForm')">
              <svg-icon icon-class="user1"
                        slot="suffix"></svg-icon>
            </el-input>
          </el-form-item>
          <el-form-item :label="$t('loginModule.password')+'：'"
                        prop="password">
            <el-input v-model.trim="loginForm.password"
                      autocomplete="new-password"
                      :type="passType"
                      placeholder="Please input your password."
                      @keyup.enter.native="submitFrom('loginForm')">
              <svg-icon :icon-class="passType == 'password' ? 'hide' : 'view'"
                        slot="suffix"
                        @click.native="handlePassView"></svg-icon>
            </el-input>
          </el-form-item>
          <el-form-item :label="$t('loginModule.validCode')+'：'"
                        prop="validCode"
                        class="validCode">
            <el-input v-model="loginForm.validCode"
                      @keyup.enter.native="submitFrom('loginForm')">
              <template slot="append"
                        style="background:#fff;">
                <img :src="validCodeUrl"
                     style="margin-left:4px;"
                     alt="Code"
                     slot="append"
                     width="110"
                     height="40"
                     @click="getValidCode">
              </template>
            </el-input>
          </el-form-item>
          <el-form-item class="bottom-label">
            <el-checkbox v-model="checkAgreement">{{$t('loginModule.agreement')}} <a href="javascript:void(0);"
                 @click="readPrivacyPolicy = true">{{$t('loginModule.privacyPolicy')}}</a>.</el-checkbox>
            <el-button :loading="submitLoad"
                       type="primary"
                       class="login-btn"
                       style="width:100%;height:48px;font-size:16px;"
                       @click="submitFrom('loginForm')"
                       :disabled="!checkAgreement">{{$t('loginModule.login')}}</el-button>
          </el-form-item>
        </el-form>
        <!-- 表单模块结束 -->

        <!-- 跳转模块开始 -->
        <div class="sp_login_skip">
          <div>
            <router-link :to="{path:'/forgotPassword'}">{{$t("loginModule.forgotPassword")}}</router-link>
            <router-link :to="{path:'/register'}">{{$t("loginModule.register")}}</router-link>
          </div>
        </div>
      </div>
      <!-- 跳转模块结束 -->
      <div class="footer-label">
        <p class="sp_login_copyRight">Sangfor Official WebsiteSangfor Community Copyright 2026 SANGFOR TECHNOLOGIES INC.</p>
      </div>
    </div>

    <!-- 协议模块 -->
    <privacy-policy v-if="readPrivacyPolicy"
                    :showDialog="readPrivacyPolicy"
                    @confirm="confirm"
                    @updataDialogType="updataDialogType"></privacy-policy>
  </div>
</template>

<script>
import { checkHavetEmail } from '@/api/loginApi.js'
import PrivacyPolicy from '@c/privacyPolicy.vue';
import { loginEncrypt, registerEncrypt } from '@/utils/encrypt.js'
import SangforLogo from '../../components/sangforLogo.vue';
export default {
  components: { PrivacyPolicy, SangforLogo },
  name: 'login',
  data () {
    var checkEmail = (rule, value, callback) => {
      const Reg = /^([a-zA-Z0-9_+-.])+@([a-zA-Z0-9_+-])+((\.[a-zA-Z0-9_-]{2,20}){1,4})$/
      if (!value) {
        return callback(new Error('Please input Email.'))
      } 
      else {
        // if (Reg.test(value)) {
        //   checkHavetEmail(registerEncrypt(value)).then(res => {
        //     if (res.code == 500) {
        //       return callback(new Error(res.msg))
        //     } else {
              return callback()
        //     }
        //   })
        // } else {
        //   return callback("Your email format is wrong, please check and try it again.")
        // }
      }
    }
    return {
      loginForm: {
        email: '',
        password: '',
        validCode: '',
        deviceId: '',
      },
      loginRules: {
        email: [
          { required: false, validator: checkEmail, trigger: 'blur' }
        ],
        password: [
          { required: false, message: 'Please input Password.', trigger: 'blur' }
        ],
        validCode: [
          { required: false, message: 'Please input Verification Code.', trigger: 'blur' }
        ],
      },
      passType: 'password',
      validCodeUrl: '',
      checkAgreement: false,
      readPrivacyPolicy: false,
      submitLoad: false,
    }
  },
  mounted () {
    // if (localStorage.getItem('readPrivacyPolicy')) {
    //   this.readPrivacyPolicy = false
    // } else {
    //   this.readPrivacyPolicy = true
    // }
  },
  methods: {
    //切换密码框密码显示隐藏
    handlePassView () {
      this.passType = this.passType == 'password' ? 'text' : 'password';
    },

    //获取图形验证码
    getValidCode () {
      let num = "";
      for (let i = 0; i < 4; i++) {
        num += parseInt(Math.random() * 10);
      }
      this.loginForm.deviceId = num;
      this.validCodeUrl =
        process.env.VUE_APP_BASE_URL + "api-auth/validata/code/" + num;
    },

    //登录
    submitFrom (loginForm) {
      if (!this.checkAgreement) return
      this.$refs[loginForm].validate(valid => {
        if (valid) {
          this.submitLoad = true;
          let loginInfo = {
            codes: JSON.parse(JSON.stringify(this.loginForm.validCode.toLowerCase())),
            deviceId: this.loginForm.deviceId,
          };
          loginInfo.loginCode = loginEncrypt({
            username: this.loginForm.email,
            password: this.loginForm.password,
          })
          this.$store.dispatch('Login', loginInfo).then((res) => {
            this.submitLoad = false;
            this.$router.push({ path: '/layout' })
            Vue.ls.set('token', res.access_token)
          }).catch(() => {
            this.getValidCode()
            this.submitLoad = false;
          })
        }
      })
    },

    //更新弹出框状态
    updataDialogType (val) {
      this.readPrivacyPolicy = val;

    },
    confirm (val) {
      this.readPrivacyPolicy = val;
      localStorage.setItem('readPrivacyPolicy', 1)
      this.$store.commit('SET_READ_PRIVACE_POLICY', true)
    }
  },

  created () {
    this.getValidCode()
  }
}
</script>

<style lang="scss" scoped>
.sp_login {
  width: 100%;
  height: 100%;
  background: url("../../assets/img/background.jpg") no-repeat 50%;
  background-size: cover;
  position: relative;
  min-width: 1024px;
  @media screen and (max-width: 1100px) {
    .sp_login_introduce {
      display: none;
    }
  }

  @media screen and (min-width: 1100px) {
    .sp_login_introduce {
      display: block;
    }
  }
  .sp_login_introduce {
    position: absolute;
    top: 260px;
    left: 155px;
    width: 29%;
    h1 {
      font-size: 34px;
      line-height: 47px;
      color: #fff;
      font-weight: normal;
      width: 100%;
      margin-bottom: 30px;
    }
    p {
      font-size: 16px;
      color: #fff;
      line-height: 30px;
    }
  }
  .sp_login_module {
    width: 700px;
    height: calc(100% - 20px);
    background: #fff;
    border-radius: 4px;
    padding: 14px 24px;
    position: absolute;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    top: 10px;
    right: 10px;
    // transform: translate(0, -50%);
    .title-logo {
      // margin-bottom: 55px;
    }
    .login-content {
      height: calc(100% - 80px);
      overflow-y: auto;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      .product-name {
        text-align: center;
        font-size: 24px;
        font-weight: 500;
        color: #13161a;
      }
    }
    .sp_login_form {
      padding: 0 100px;
      margin-top: 56px;
      display: flex;
      flex-wrap: wrap;
      flex-direction: column;
      align-items: center;
      .svg-icon {
        color: #8c8c8c;
        font-size: 18px;
        vertical-align: -5px;
        cursor: pointer;
      }
      .validCode {
        /deep/ .el-input-group {
          line-height: 0;
        }
        /deep/ .el-input-group__append {
          padding: 0;
          border: 0;
          cursor: pointer;
        }
      }
      /deep/.el-form-item {
      }
      /deep/.el-checkbox__input.is-checked + .el-checkbox__label {
        color: #545c66;
      }
      /deep/.el-input__suffix {
        right: 10px;
      }
      /deep/.el-form-item__label {
        height: 16px;
        line-height: 16px;
        color: #545c66;
        font-size: 14px;
        margin-bottom: 12px;
        font-weight: 400;
      }
      /deep/.el-form-item__content {
        width: 400px;
      }
      /deep/.el-checkbox {
        margin-bottom: 19px;
      }
      /deep/.el-checkbox__label {
        font-size: 14px;
        font-weight: 400;
        color: #333940;
      }
    }
    .sp_login_skip {
      padding: 0 100px;
      display: flex;
      justify-content: center;
      div {
        display: flex;
        width: 400px;
        justify-content: space-between;
        font-size: 14px;
      }
    }
    .footer-label {
      padding: 0 120px;
      // margin-top: 55px;
      .sp_login_copyRight {
        width: 400px !important;
        width: 100%;
        text-align: center;
        color: #a1a8b3;
        font-size: 14px;
        opacity: 0.8;
      }
    }
  }
}
</style>